import React from "react";
import { Card, CardContent, CardMedia, Typography, Box } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

function CourseCard({ item, onPlay }) {
  return (
    <Card
      sx={{
        display: "flex",
        width: "100%",
        mb: 2,
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        overflow: "hidden",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: "0 6px 16px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      {/* Thumbnail Section */}
      <Box
        sx={{
          position: "relative",
          width: "140px",
          minWidth: "140px",
          height: "120px",
          p: 1,
        }}
      >
        <CardMedia
          component="img"
          image={item?.thumbnail}
          alt={item?.title}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: "12px",
          }}
        />
        {/* Play Button Overlay */}
        <Box
          onClick={() => onPlay(item)}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "42px",
            height: "42px",
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
              transform: "translate(-50%, -50%) scale(1.1)",
            },
          }}
        >
          <PlayArrowIcon
            sx={{
              color: "#FF6B35",
              fontSize: "28px",
              ml: "4px",
            }}
          />
        </Box>
      </Box>

      {/* Text Content */}
      <CardContent
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          py: 2,
          px: 3,
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            color: "#000",
            lineHeight: 1.3,
          }}
        >
          {item?.title}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default CourseCard;
